import React from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

if (typeof window !== "undefined" && !window.__weddly_error_listeners_attached) {
  window.__weddly_error_listeners_attached = true;
  
  window.addEventListener("error", (event) => {
    try {
      if (event?.error && event.error.name === "DOMException" && event.error.message?.includes("PerformanceServerTiming")) {
        return;
      }
      const msg = event?.message || "Uncaught Error";
      const stack = event?.error?.stack || `${event?.filename || ""}:${event?.lineno || 0}:${event?.colno || 0}`;
      api.post("/logs/error", {
        source: "frontend_window",
        message: msg,
        stack_trace: stack,
        path: window.location.pathname,
      }).catch(() => {});
    } catch {}
  });

  window.addEventListener("unhandledrejection", (event) => {
    try {
      const reason = event?.reason;
      const msg = reason?.message || String(reason || "Unhandled Promise Rejection");
      const stack = reason?.stack || "";
      api.post("/logs/error", {
        source: "frontend_promise",
        message: msg,
        stack_trace: stack,
        path: window.location.pathname,
      }).catch(() => {});
    } catch {}
  });
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    try {
      api.post("/logs/error", {
        source: "frontend_ui",
        message: error?.message || String(error),
        stack_trace: (error?.stack || "") + "\nComponent Stack:\n" + (errorInfo?.componentStack || ""),
        path: window.location.pathname,
      }).catch(() => {});
    } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center p-6 bg-background text-foreground text-center">
          <div className="max-w-md space-y-4">
            <h1 className="text-2xl font-serif font-bold">Terjadi Kesalahan Aplikasi</h1>
            <p className="text-sm text-muted-foreground">
              Aplikasi mengalami masalah tak terduga. Silakan muat ulang halaman.
            </p>
            <Button onClick={() => window.location.reload()}>Muat Ulang Halaman</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
